import type { Http } from '../http'
import { recordsMethods, type RecordsApi } from './records'
import { schemaMethods, type SchemaApi } from './schema'
import { viewsMethods, type ViewsApi } from './views'
import { peopleMethods, type PeopleApi } from './people'
import { commerceMethods, type CommerceApi } from './commerce'
import { connectorsMethods, type ConnectorsApi } from './connectors'
import { privacyMethods, type PrivacyApi } from './privacy'
import { accountingSyncMethods, type AccountingSyncApi } from './accountingSync'

export * from './records'
export * from './schema'
export * from './views'
export * from './people'
export * from './commerce'
export * from './connectors'
export * from './privacy'
export * from './accountingSync'

/** The CRM console API beyond the original contract: one interface per area, merged into ConsoleApi. */
export interface CrmExtApi extends RecordsApi, SchemaApi, ViewsApi, PeopleApi, CommerceApi, ConnectorsApi, PrivacyApi, AccountingSyncApi {}

export function crmExtMethods(http: Http): CrmExtApi {
  return { ...recordsMethods(http), ...schemaMethods(http), ...viewsMethods(http), ...peopleMethods(http), ...commerceMethods(http), ...connectorsMethods(http), ...privacyMethods(http), ...accountingSyncMethods(http) }
}
